import { useState } from "react";

const footerNav = [
  { href: "#features", label: "核心功能" },
  { href: "#works", label: "在追作品" },
  { href: "#calendar", label: "追更日历" },
  { href: "#steps", label: "使用流程" },
  { href: "#faq", label: "常见问题" },
  { href: "#contact", label: "联系我们" },
];

const social = [
  { icon: "ri-wechat-line", label: "微信公众号" },
  { icon: "ri-bilibili-line", label: "哔哩哔哩" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-mail-line", label: "邮箱" },
];

export default function Footer() {
  const [year] = useState(new Date().getFullYear());

  return (
    <footer className="bg-background-200">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <a href="#home" className="flex items-center gap-2" aria-label="汗汗虫虫漫画 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">汗汗虫虫漫画</span>
            </a>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              漫画追更管理平台，用更新提醒、追更日历与自动续读，帮你不错过任何一次更新。
            </p>
          </div>

          <nav className="grid grid-cols-2 gap-2" aria-label="页脚导航">
            {footerNav.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div>
            <p className="text-sm font-semibold text-foreground-900">关注我们</p>
            <div className="mt-4 flex items-center gap-3">
              {social.map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
            <p className="mt-4 text-xs text-foreground-500">意见反馈：support@hanhan-manga.example</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© {year} 汗汗虫虫漫画 保留所有权利。</p>
          <p className="text-xs text-foreground-600">追更不迷路 · 更新不错过</p>
        </div>
      </div>
    </footer>
  );
}